/**
 * @generated SignedSource<<42bba41095e2857b0f58aa56a1d02144>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSidebar_item$data = {
  readonly hasPrivateListing: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarItemInfo_item" | "CheckoutSidebarPromotion_item" | "CheckoutTotals_item" | "useCustomsMessagingQuery_item">;
  readonly " $fragmentType": "CheckoutSidebar_item";
};
export type CheckoutSidebar_item$key = {
  readonly " $data"?: CheckoutSidebar_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebar_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSidebar_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarItemInfo_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTotals_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarPromotion_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useCustomsMessagingQuery_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPrivateListing",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "78e898d9589cea30e73c44c9671c94c3";

export default node;
